const myColors = { 
    primary: {
      main: '#6A84AA',
      light: '#B3CAF2'
    },
    dark: {
      main: '#1C1C1F',
      light: '#343444'
    },
    whiteGray: "#FCFCFC",
    purpleBlack: "#1C1C1F",
    purple: "#343444"
  }

  export default myColors